import React from 'react'
import styles from './ChatHeader.module.scss'
import ProfileAvatar from '../../../UI/components/ProfileAvatar/ProfileAvatar'
import useLocalization from 'hooks/useLocalization'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'

const ChatHeader = ({
  dealData,
  onOpenWazzup,
  isWazzupLoading,
  isWazzupOpen,
  onCloseWazzup,
}) => {
  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      conversation: 'Conversation',
    },
  })

  const hasWazzupData =
    dealData?.manager?.wazzup_user_id &&
    (dealData?.client?.whatsapp ||
      dealData?.lead?.client?.whatsapp ||
      dealData?.client?.phone ||
      dealData?.lead?.client?.phone)

  return (
    <div className={styles.clientHeader}>
      <div className={styles.header}>
        <ProfileAvatar
          name={dealData?.client?.name || dealData?.lead?.client?.name}
        />
        <div className={styles.name}>
          {dealData?.client?.name || dealData?.lead?.client?.name}
        </div>

        <div className={styles.headerActions}>
          {isWazzupOpen ? (
            <SuperButton
              variant='reset'
              onClick={onCloseWazzup}
              className={styles.closeButton}
            >
              Закрыть Wazzup
            </SuperButton>
          ) : (
            hasWazzupData && (
              <SuperButton
                variant='original'
                onClick={onOpenWazzup}
                disabled={isWazzupLoading}
                className={styles.wazzupButton}
              >
                {isWazzupLoading ? 'Загрузка...' : 'Открыть Wazzup'}
              </SuperButton>
            )
          )}
        </div>
      </div>

      {dealData?.session_id && (
        <div className={styles.conversation}>
          {translate.conversation} № {dealData?.session_id}
        </div>
      )}
    </div>
  )
}

export default ChatHeader
